const titles = document.querySelectorAll('.block-content-wraper > h4');
const titlesHeights = [];
let titleHighest = 0;
const descriptions = document.querySelectorAll('.block-content-wraper > .rte');
const descriptionsHeights = [];
let descriptionHighest = 0;
const prices = document.querySelectorAll('.block-content-wraper > .price');
const pricesHeights = [];
let priceHighest = 0;

titles.forEach(function(title) {
  titlesHeights.push(title.clientHeight);
  // get highest number
  titleHighest = Math.max(...titlesHeights); 
});
descriptions.forEach(function(description) {
  descriptionsHeights.push(description.clientHeight);
  // get highest number
  descriptionHighest = Math.max(...descriptionsHeights); 
});
prices.forEach(function(price) {
  pricesHeights.push(price.clientHeight);
  // get highest number
  priceHighest = Math.max(...pricesHeights);
});

document.addEventListener('DOMContentLoaded', function() {
  assignheights();
});

window.addEventListener('resize', function() {
  let mTitles = document.querySelectorAll('.block-content-wraper > h4');
  let mTitlesHeights = [];
  let mTitleHighest = 0;
  mTitles.forEach(function(mtitle){
    mtitle.style.removeProperty('height');
    mTitlesHeights.push(mtitle.clientHeight);
    mTitleHighest = Math.max(...mTitlesHeights); 
  });
  for (let entry of mTitles) {
    entry.style.cssText = `height: ${mTitleHighest}px;`
  }

  let mDescriptions = document.querySelectorAll('.block-content-wraper > .rte');
  let mDescriptionsHeights = [];
  let mDescriptionHighest = 0;
  mDescriptions.forEach(function(mdescription){
    mdescription.style.removeProperty('height');
    mDescriptionsHeights.push(mdescription.clientHeight);
    mDescriptionHighest = Math.max(...mDescriptionsHeights); 
  });
  for (let entry of mDescriptions) {
    entry.style.cssText = `height: ${mDescriptionHighest}px;`
  }
  
  let mPrices = document.querySelectorAll('.block-content-wraper > .rte');
  let mPricesHeights = [];
  let mPriceHighest = 0;
  mPrices.forEach(function(mdescription){
    mdescription.style.removeProperty('height');
    mPricesHeights.push(mdescription.clientHeight);
    mPriceHighest = Math.max(...mPricesHeights); 
  });
  for (let entry of mPrices) {
    entry.style.cssText = `height: ${mPriceHighest}px;`
  }
});

const assignheights = () => {
   titles.forEach(function(title) {
     title.style.cssText = 'height:'+titleHighest+'px;'
   });
   descriptions.forEach(function(description) {
     description.style.cssText = 'height:'+descriptionHighest+'px;'
   });
   prices.forEach(function(price) {
     price.style.cssText = 'height:'+priceHighest+'px;'
   });
}

const submitButtons = document.querySelectorAll('.multicolumn__column form button');
submitButtons.forEach(function(submitButton) {
  submitButton.addEventListener('click', function(){
    submitButtons.forEach(function(b) {
      if(b !== submitButton) {
        b.classList.add('hide-loading');
      } else {
        b.classList.remove('hide-loading');
      }
    });
  });
});